function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.526 13a.5.5 0 01-.5-.5V.5a.5.5 0 01.5-.5c3.63 0 6.901 1.328 9.212 3.741 2.247 2.346 3.406 5.464 3.263 8.781a.5.5 0 01-.5.478H11.526zm11.486-1c.006-2.859-1.053-5.538-2.997-7.568-2.009-2.098-4.838-3.308-7.99-3.423V12h10.987zM12.026 22.001a.5.5 0 01-.5-.5v-2a.5.5 0 011 0v2a.5.5 0 01-.5.5zM2.526 12.501a.5.5 0 010-1h2a.5.5 0 010 1h-2zM6.723 7.197a.5.5 0 01-.354-.146L4.955 5.637a.5.5 0 01.707-.707l1.414 1.414a.5.5 0 01-.353.853z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.33 7.197a.5.5 0 01-.354-.853L18.39 4.93a.5.5 0 11.708.707l-1.414 1.414a.501.501 0 01-.354.146zM18.744 19.218a.5.5 0 01-.354-.146l-1.414-1.414a.5.5 0 01.708-.707l1.414 1.414a.5.5 0 01-.354.853zM5.309 19.218a.5.5 0 01-.354-.853l1.414-1.414a.5.5 0 11.708.707l-1.414 1.414a.501.501 0 01-.354.146z"
});

function SvgMdConstraintAllowedTimes(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "mdConstraintAllowedTimes.79242.svg";
export { SvgMdConstraintAllowedTimes as ReactComponent };